import React, { createContext, useContext } from 'react';

export interface SyncedInfoContextProps {
  versionStatus?: number;
  userViewStatus?: number;
  isEditMode?: boolean;
  isViewMode?: boolean;
  shareWithAll?: boolean;
}
const SyncedInfoContext = createContext<SyncedInfoContextProps | undefined>(
  undefined
);

const SyncedInfoProvider: React.FC<{ value: SyncedInfoContextProps }> = ({
  children,
  value,
}) => {
  return (
    <SyncedInfoContext.Provider key="synced-info-context" value={value}>
      {children}
    </SyncedInfoContext.Provider>
  );
};

const useSyncedInfo = () => {
  const context = useContext<SyncedInfoContextProps | undefined>(
    SyncedInfoContext
  );
  if (context === undefined) {
    throw new Error(
      'useSyncedInfo can only be used inside of SyncedInfoProvider'
    );
  }

  return context || {};
};

export { SyncedInfoProvider, useSyncedInfo };
